import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nav"]

  open(event) {
    event.preventDefault()
    this.navTarget.style.height = "100%"
  }

  close(event) {
    event.preventDefault()
    this.navTarget.style.height = "0%"
  }
}
